import React, { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
} from "react-bootstrap-table";
import _ from "lodash";
import TimeStamp from "react-timestamp";
import { confirmAlert } from "react-confirm-alert";
import { customLog } from "../../variables/Variables";
import { fire, auth } from "../../firebase/index";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";
import DetailsButton from "../Locklist/DetailsButton";

// Css
import "../../assets/css/groupmanagement.css";

import LocalizedStrings from "react-localization";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    viewLocksBtn: "View Lock Group Locks",
    groupLocksHeader: "Lock Group Locks",
    nameHeader: "Lock Name",
    lockSerialHeader: "Lock Serial",
    lockModelHeader: "Lock Model",
    shareModeHeader: "Share Mode",
    headerShareBy: "Share By",
    startHeader: "Start",
    endHeader: "End",
    nonSharedLockTitle: "Non-Shared Lock",
    normalGrantAccess: "Normal Grant Access",
    multiApproveAccess: "Multi Approve Access",
    multiApproveOneTimeAccess: "Multi Approve & One Time Access",
    oneTimeAccess: "One Time Access",
    resultTitle1: "Showing ",
    resultTitle2: " to ",
    resultTitle3: " of ",
    resultTitle4: " Results",
    noDataTitle: "There is no data to display",
    headerShareMode: "Share Mode",
    headerPermission: "Permission",
  },
  ja: {
    viewLocksBtn: "ロック一覧",
    groupLocksHeader: "登録スマートロック",
    nameHeader: "ロック名",
    lockSerialHeader: "ロックシリアル",
    lockModelHeader: "ロックモデル",
    shareModeHeader: "共有モード",
    startHeader: "アクセス開始日",
    endHeader: "アクセス終了日",
    normalGrantAccess: "アクセス譲渡",
    headerShareBy: "シェア状況",
    multiApproveAccess: "承認者追加",
    multiApproveOneTimeAccess: "承認者追加＆ワンタイム解錠",
    oneTimeAccess: "ワンタイム解錠",
    nonSharedLockTitle: "共有していません",
    resultTitle1: "表示 ",
    resultTitle2: " へ",
    resultTitle3: " の ",
    resultTitle4: " 結果",
    noDataTitle: "表示するデータがありません。",
    headerShareMode: "共有モード",
    headerPermission: "権限",
  },
  es: {
    viewLocksBtn: "Ver Candados Grupo",
    groupLocksHeader: "Candados del Grupo",
    nameHeader: "Nombre de la Candado",
    lockSerialHeader: "Número de Serie de la Candado",
    lockModelHeader: "Modelo de la Candado",
    shareModeHeader: "Modo de Compartición",
    headerShareBy: "Compartido Por",
    startHeader: "Inicio",
    endHeader: "Fin",
    nonSharedLockTitle: "Candado No Compartida",
    normalGrantAccess: "Acceso Normal",
    multiApproveAccess: "Acceso de Aprobación Múltiple",
    multiApproveOneTimeAccess: "Aprobación Múltiple y Acceso Único",
    oneTimeAccess: "Acceso Único",
    resultTitle1: "Mostrando ",
    resultTitle2: " a ",
    resultTitle3: " de ",
    resultTitle4: " Resultados",
    noDataTitle: "No hay datos para mostrar",
    headerShareMode: "Modo de Compartición",
    headerPermission: "Permiso",
  },
});

export class LockGroupLocksButton extends Component {
  constructor(props) {
    super(props);

    const cell = this.props.cellValue;
    const row = this.props.rowValue;
    // console.log("cell:", cell);
    // console.log("row:", row);

    var lockgrouparray = [];
    // console.log(cell.senderUID);
    fire
      .database()
      .ref("lockGroupManagement")
      .child(cell.senderUID)
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        const data = snapshot.val();
        const filteredData = Object.entries(data).filter(([key, value]) => {
          return value.name === row.name;
        });
        const locksArray = filteredData.map(([key, value]) =>
          Object.keys(value.locks)
        );
        _.forEach(locksArray, (lockDataArray, index) => {
          _.forEach(lockDataArray, (lockId, key) => {
            // console.log(lockId);
            // console.log(index);

            fire
              .database()
              .ref("userLocks")
              .child(auth.currentUser.uid)
              .orderByKey()
              .once("value")
              .then((snapshot) => {
                const tempArray = this.snapshotToArray(snapshot).filter(
                  (item) => {
                    return item.id === lockId;
                  }
                );

                // console.log(tempArray);

                tempArray.forEach((item) => {
                  const eachLock = {
                    id: item.id,
                    lockName: item.Name,
                    lockSerial: item.ip45SerialNumber,
                    lockModel: item.Type,
                    sharedBy: item.sharedBy,
                    startDate: item.shareStartTime,
                    sharingMode: item.sharingMode,
                    endDate: item.shareEndTime,
                    access: item,
                    shareAccessToken: item.shareAccessToken,
                  };
                  lockgrouparray.push(eachLock);
                });
              });
          });
        });
      });

    this.state = {
      _notificationSystem: null,
      cell: cell,
      row: row,
      showPopup: false,
      groupID: row.groupID,
      groupLocksArrayList: lockgrouparray,
      isSuperAdmin: false,
      isAdmin: false,
      superAdminID: "",
    };

    this.handleGroupLocksPopupOpen = this.handleGroupLocksPopupOpen.bind(this);
    this.handleGroupLocksPopupClose = this.handleGroupLocksPopupClose.bind(
      this
    );
    this.checkStartDate = this.checkStartDate.bind(this);
    this.checkEndDate = this.checkEndDate.bind(this);
    this.renderDetailsBtn = this.renderDetailsBtn.bind(this);
  }

  componentWillMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }

    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((superAdmin) => {
            const superAdminData = superAdmin.val();

            const memberDetails = superAdminData.members;

            for (let eachMemberId in memberDetails) {
              const eachMemberDetails = memberDetails[eachMemberId];
              const eachMemberEmail = eachMemberDetails.memberEmail;

              if (eachMemberEmail === auth.currentUser.email) {
                const superAdminID = superAdmin.key;
                this.setState({
                  isAdmin: eachMemberDetails.isAdmin,
                  isSuperAdmin: eachMemberDetails.isSuperAdmin,
                  superAdminID: superAdminID,
                });
              }
            }
          });
        }
      });
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      // customLog(item)
      // customLog(item.key)

      returnArr.push(item);
    });
    // customLog(returnArr)
    return returnArr;
  };

  isASharedMode(sharingMode) {
    if (sharingMode != null && sharingMode.includes("RECURR")) {
      if (sharingMode === "NORMAL-RECURR") {
        return localizationStrings.recurringNonSharedLockTitle;
      } else if (sharingMode === "NORMAL-RECURR-TIMED") {
        return localizationStrings.recurringNonSharedLockTitle;
      }
    } else {
      if (
        sharingMode === "" ||
        sharingMode === "NORMAL" ||
        sharingMode == null
      ) {
        return localizationStrings.nonSharedLockTitle;
      } else if (sharingMode === "MULTI") {
        return localizationStrings.multiApproveAccess;
      } else if (sharingMode === "MULTI-OTA") {
        return localizationStrings.multiApproveOneTimeAccess;
      } else if (sharingMode === "OTA") {
        return localizationStrings.oneTimeAccess;
      }
    }
  }

  showNotification(msg, lvl, position, duration) {
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        ></span>
      ),
      message: <div>{msg}</div>,
      level: lvl,
      position: position,
      autoDismiss: duration,
    });
  }

  handleGroupLocksPopupOpen() {
    this.setState({
      showPopup: true,
    });
  }

  handleGroupLocksPopupClose() {
    this.setState({
      showPopup: false,
    });
  }

  renderDetailsBtn(shareAccessToken) {
    const Locklist = this.state.groupLocksArrayList;

    if (shareAccessToken !== "") {
      for (const i in Locklist) {
        if (Locklist[i].shareAccessToken === shareAccessToken) {
          if (
            Locklist[i].sharingMode === "MULTI" ||
            Locklist[i].sharingMode === "MULTI-OTA"
          ) {
            return <DetailsButton shareAccessToken={shareAccessToken} />;
          } else {
            return "-";
          }
        }
      }
    } else {
      return "-";
    }
  }

  checkStartDate(shareStartTime) {
    if (shareStartTime === 0 || shareStartTime === "") {
      return "∞";
    } else {
      if (localizationStrings.getLanguage() === "ja") {
        var japanDate =
          new Intl.DateTimeFormat("ja-JP", {
            year: "numeric",
          }).format(shareStartTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            month: "numeric",
          }).format(shareStartTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            day: "numeric",
          }).format(shareStartTime * 1000);
        var japanTime = new Intl.DateTimeFormat("ja-JP", {
          hourCycle: "h12",
          hour: "numeric",
          minute: "2-digit",
        }).format(shareStartTime * 1000);
        return japanDate + " " + japanTime;
      } else {
        // return <TimeStamp time={shareStartTime} format="full" includeDay />;
        return <TimeStamp time={shareStartTime} format="full" />;
      }
    }
  }

  checkEndDate(shareEndTime) {
    if (shareEndTime === 0 || shareEndTime === "") {
      return "∞";
    } else {
      if (localizationStrings.getLanguage() === "ja") {
        var japanDate =
          new Intl.DateTimeFormat("ja-JP", {
            year: "numeric",
          }).format(shareEndTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            month: "numeric",
          }).format(shareEndTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            day: "numeric",
          }).format(shareEndTime * 1000);
        var japanTime = new Intl.DateTimeFormat("ja-JP", {
          hourCycle: "h12",
          hour: "numeric",
          minute: "2-digit",
        }).format(shareEndTime * 1000);
        return japanDate + " " + japanTime;
      } else {
        // return <TimeStamp time={shareEndTime} format="full" includeDay />;
        return <TimeStamp time={shareEndTime} format="full" />;
      }
    }
  }

  getLockModelName(type) {
    let lock = "Lock Model Unknown";
    if (type === 1) {
      lock = "Debossed Lock";
    } else if (type === 2) {
      lock = "TSA Travel Lock";
    } else if (type === 3) {
      lock = "Padlock with NFC and Bluetooth";
    } else if (type === 4) {
      lock = "IP45 Padlock";
    } else if (type === 10) {
      lock = "IP66 Padlock";
    } else if (type === 7 || type === 8 || type === 9) {
      lock = "Lock Out Tag Out";
    } else if (type === 11) {
      lock = "Anti-Cut Padlock";
    } else if (type === 12) {
      lock = "Heavy Duty Padlock";
    } else if (type === 13) {
      lock = "IP66 LOTO";
    }
    // IP45 Padlock

    return lock;
  }

  isASharedLock(sharedBy) {
    if (sharedBy === "") {
      return localizationStrings.nonSharedLockTitle;
    } else {
      return sharedBy;
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const customTotal = (from, to, size) => (
      <span
        className="react-bootstrap-table-pagination-total"
        style={{
          float: "right",
          color: "rgb(128, 128, 128)",
          fontWeight: "lighter",
        }}
      >
        {localizationStrings.resultTitle1}
        {from}
        {localizationStrings.resultTitle2}
        {to}
        {localizationStrings.resultTitle3}
        {size}
        {localizationStrings.resultTitle4}
      </span>
    );

    const options = {
      page: 1, // which page you want to show as default
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "100",
          value: 100,
        },
        {
          text: "All",
          value: this.state.groupLocksArrayList.length,
        },
      ], // you can change the dropdown list for size per page
      sizePerPage: 10, // which size per page you want to locate as default
      pageStartIndex: 1, // where to start counting the pages
      paginationSize: 3, // the pagination bar size.
      prePage: "<", // Previous page button text
      nextPage: ">", // Next page button text
      firstPage: "<<", // First page button text
      lastPage: ">>", // Last page button text
      paginationShowsTotal: customTotal,
      noDataText: localizationStrings.noDataTitle,
    };

    const columnHover = (cell, row, enumObject, rowIndex) => {
      return cell;
    };

    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
        <Button
          onClick={this.handleGroupLocksPopupOpen}
          className="btn btn-info"
          style={{ borderRadius: "50px" }}
        >
          {localizationStrings.viewLocksBtn}
        </Button>
        {/* //! Popup for Group Locks Button */}
        <Modal
          show={this.state.showPopup}
          onHide={this.handleGroupLocksPopupClose}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.groupLocksHeader}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "30px 30px 40px 30px" }}>
            <BootstrapTable
              data={this.state.groupLocksArrayList}
              bordered={false}
              pagination={true}
              options={options}
              // selectRow={{ mode: "checkbox", bgColor: "#eeeeee" }}
              // search
              // deleteRow
            >
              <TableHeaderColumn dataField="id" isKey={true} hidden>
                Key
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="lockName"
                dataSort
                columnTitle={columnHover}
              >
                {localizationStrings.nameHeader}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="lockSerial"
                dataSort
                columnTitle={columnHover}
              >
                {localizationStrings.lockSerialHeader}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="lockModel"
                dataFormat={this.getLockModelName}
                columnTitle={columnHover}
              >
                {localizationStrings.lockModelHeader}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataSort
                dataField="sharedBy"
                dataFormat={this.isASharedLock}
                columnTitle={columnHover}
              >
                {localizationStrings.headerShareBy}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataSort
                dataField="sharingMode"
                dataFormat={this.isASharedMode}
              >
                {localizationStrings.headerShareMode}
              </TableHeaderColumn>
              <TableHeaderColumn
                width="150px"
                dataField="shareAccessToken"
                dataFormat={this.renderDetailsBtn}
              >
                {localizationStrings.headerPermission}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="startDate"
                dataFormat={this.checkStartDate}
                // columnTitle={this.checkStartDate}
                tdStyle={{ whiteSpace: "normal" }}
              >
                {localizationStrings.startHeader}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="endDate"
                dataFormat={this.checkEndDate}
                // columnTitle={this.checkEndDate}
                tdStyle={{ whiteSpace: "normal" }}
              >
                {localizationStrings.endHeader}
              </TableHeaderColumn>
            </BootstrapTable>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default LockGroupLocksButton;
